// js
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import OverviewIndexedDataSummary from '../OverviewIndexedDataSummary';
// css
import '../../../styles/components/analytics/OverviewAreaItem.scss';


class OverviewAreaItem extends Component {

  followLink(area) {
    browserHistory.push(browserHistory.getCurrentLocation().pathname + '/' + area.id);
  }

  renderTitle() {
    if (!this.props.subarea) {
      return <a onClick={() => this.followLink(this.props.area)}>{this.props.area.title}</a>;
    } else {
      return this.props.subarea.title;
    }
  }

  render() {
    return (
      <div className='analytics__overview-area-item'>
        <div className='row'>
          <div className='col-md-4 analytics__overview-area-item__overview'>
            <div className='analytics__overview-area-item__title'>
              {this.renderTitle()}
            </div>
            <OverviewIndexedDataSummary
              progressBarHeight={24}
              progressBarStripeColor='black'
              stats={this.props.stats}
            />
          </div>
        </div>
      </div>
    );
  }
}

OverviewAreaItem.propTypes = {
  area: PropTypes.object.isRequired,
  stats: PropTypes.object.isRequired,
  subarea: PropTypes.object
};

export default OverviewAreaItem;



// WEBPACK FOOTER //
// ./src/components/analytics/pptx/OverviewAreaItem.js